import './index.less';

import { Space, Text } from '@bfe/moly';
import { ArrowchevronRightIcon } from '@bfe/moly-icons';

import LogoTelegram from '@/assets/logo-telegram.svg';
import { useI18nContext } from '@/i18n/I18n';

import { techopsSupportConfig } from './config';

const TechopsSupport = () => {
  const [$t] = useI18nContext();

  return (
    <section className="techops-support">
      <div>
        <img src={LogoTelegram} alt="" />
        <span className="techops-support-text">{$t('techopsSupportText')}</span>
        <Space size={24} className="techops-support-group">
          {Object.keys(techopsSupportConfig).map((key) => {
            const { i18n, link } =
              techopsSupportConfig[key as keyof typeof techopsSupportConfig];
            return (
              <Text.Link
                size={12}
                href={link}
                key={key}
                type="title"
                target="_blank"
              >
                {$t(i18n)}
                <ArrowchevronRightIcon
                  style={{ width: '14px', height: '14px' }}
                />
              </Text.Link>
            );
          })}
        </Space>
      </div>
    </section>
  );
};

export default TechopsSupport;
